import React from 'react';

const UserIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        height: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="15"
        height="22.5"
        viewBox="0 0 18 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 11.75C11.7614 11.75 14 9.51142 14 6.75C14 3.98858 11.7614 1.75 9 1.75C6.23858 1.75 4 3.98858 4 6.75C4 9.51142 6.23858 11.75 9 11.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 24.25V21.75C1.5 20.4239 2.02678 19.1521 2.96447 18.2145C3.90215 17.2768 5.17392 16.75 6.5 16.75H11.5C12.8261 16.75 14.0979 17.2768 15.0355 18.2145C15.9732 19.1521 16.5 20.4239 16.5 21.75V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const ContractSettingsIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="17.7"
        height="23"
        viewBox="0 0 20 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.25 4.25H3.75C3.08696 4.25 2.45107 4.51339 1.98223 4.98223C1.51339 5.45107 1.25 6.08696 1.25 6.75V21.75C1.25 22.413 1.51339 23.0489 1.98223 23.5178C2.45107 23.9866 3.08696 24.25 3.75 24.25H16.25C16.913 24.25 17.5489 23.9866 18.0178 23.5178C18.4866 23.0489 18.75 22.413 18.75 21.75V6.75C18.75 6.08696 18.4866 5.45107 18.0178 4.98223C17.5489 4.51339 16.913 4.25 16.25 4.25H13.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 1.75H8.75C7.36929 1.75 6.25 2.86929 6.25 4.25C6.25 5.63071 7.36929 6.75 8.75 6.75H11.25C12.6307 6.75 13.75 5.63071 13.75 4.25C13.75 2.86929 12.6307 1.75 11.25 1.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const CustomerIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="21.3"
        height="23"
        viewBox="0 0 25 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.75 6.75C7.13071 6.75 8.25 5.63071 8.25 4.25C8.25 2.86929 7.13071 1.75 5.75 1.75C4.36929 1.75 3.25 2.86929 3.25 4.25C3.25 5.63071 4.36929 6.75 5.75 6.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 25.5V19.25L2 18V13C2 12.6685 2.1317 12.3505 2.36612 12.1161C2.60054 11.8817 2.91848 11.75 3.25 11.75H8.25C8.58152 11.75 8.89946 11.8817 9.13388 12.1161C9.3683 12.3505 9.5 12.6685 9.5 13V18L8.25 19.25V25.5"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 6.75C19.6307 6.75 20.75 5.63071 20.75 4.25C20.75 2.86929 19.6307 1.75 18.25 1.75C16.8693 1.75 15.75 2.86929 15.75 4.25C15.75 5.63071 16.8693 6.75 18.25 6.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 25.5V20.5H13.25L15.75 13C15.75 12.6685 15.8817 12.3505 16.1161 12.1161C16.3505 11.8817 16.6685 11.75 17 11.75H19.5C19.8315 11.75 20.1495 11.8817 20.3839 12.1161C20.6183 12.3505 20.75 12.6685 20.75 13L23.25 20.5H20.75V25.5"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const ContractIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="17.7"
        height="23"
        viewBox="0 0 20 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 1.75V6.75C12.5 7.08152 12.6317 7.39946 12.8661 7.63388C13.1005 7.8683 13.4185 8 13.75 8H18.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.25 24.25H3.75C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V4.25C1.25 3.58696 1.51339 2.95107 1.98223 2.48223C2.45107 2.01339 3.08696 1.75 3.75 1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 9.25H7.5"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 14.25H13.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 19.25H13.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const BenefitsIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="23"
        height="15.9"
        viewBox="0 0 26 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 1.5L18 9L24.25 4L21.75 16.5H4.25L1.75 4L8 9L13 1.5Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const DemoIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="21.2"
        height="23"
        viewBox="0 0 24 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 20.5V24.25H22V6.75L12 1.75L2 6.75V10.5"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 15.5H13.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 11.75L13.25 15.5L9.5 19.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const DocumentIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="23"
        height="19.5"
        viewBox="0 0 26 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.25 2H9.25L13 5.75H21.75C22.413 5.75 23.0489 6.01339 23.5178 6.48223C23.9866 6.95107 24.25 7.58696 24.25 8.25V18.25C24.25 18.913 23.9866 19.5489 23.5178 20.0178C23.0489 20.4866 22.413 20.75 21.75 20.75H4.25C3.58696 20.75 2.95107 20.4866 2.48223 20.0178C2.01339 19.5489 1.75 18.913 1.75 18.25V4.5C1.75 3.83696 2.01339 3.20107 2.48223 2.73223C2.95107 2.26339 3.58696 2 4.25 2"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const DashboardIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="23"
        height="23"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.75 11.75C9.51142 11.75 11.75 9.51142 11.75 6.75C11.75 3.98858 9.51142 1.75 6.75 1.75C3.98858 1.75 1.75 3.98858 1.75 6.75C1.75 9.51142 3.98858 11.75 6.75 11.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 1.75V6.75H11.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 19.25V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.25 15.5V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 14.25V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.25 13V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const RequestIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      {/* <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 485 485" width="20" height="20" fill="currentColor">
                <path d="M415,97.272V30h55V0H15v30h55v67.272c0,59.458,30.395,113.852,79.349,145.228C100.395,273.876,70,328.269,70,387.727V455
                    H15v30h455v-30h-55v-67.273c0-59.458-30.395-113.851-79.349-145.227C384.605,211.125,415,156.731,415,97.272z M298.635,228.283
                    l-9.085,3.898v20.636l9.085,3.898C351.1,279.229,385,330.654,385,387.727V455H100v-67.273c0-57.073,33.9-108.498,86.365-131.011
                    l9.085-3.898v-20.636l-9.085-3.898C133.9,205.771,100,154.346,100,97.272V30h285v67.272C385,154.346,351.1,205.771,298.635,228.283
                    z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M140,387.728V415h205v-27.272c0-56.519-45.981-102.5-102.5-102.5S140,331.209,140,387.728z M314.949,385H170.051
                    c1.438-38.719,33.385-69.772,72.449-69.772S313.511,346.281,314.949,385z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg> */}
      <svg
        width="23"
        height="23"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 26.25V10C5 9.00544 5.39509 8.05161 6.09835 7.34835C6.80161 6.64509 7.75544 6.25 8.75 6.25H21.25C22.2446 6.25 23.1984 6.64509 23.9017 7.34835C24.6049 8.05161 25 9.00544 25 10V17.5C25 18.4946 24.6049 19.4484 23.9017 20.1517C23.1984 20.8549 22.2446 21.25 21.25 21.25H10L5 26.25Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11.25H20"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 16.25H17.5"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const AdvisorIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      {/* <svg t="1627991331702" xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 1024 1024" version="1.1" p-id="1701" width="20" height="20" fill="currentColor">
                <path stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M951.182222 497.208889c2.275556-238.933333-200.248889-443.733333-441.457778-446.008889-238.933333-2.275556-434.631111 193.422222-436.906666 436.906667l-2.275556 190.008889c-1.137778 73.955556 59.164444 134.257778 131.982222 135.395555s134.257778-59.164444 135.395556-131.982222l1.137778-113.777778c1.137778-73.955556-58.026667-135.395556-131.982222-135.395555-27.306667 0-53.475556 7.964444-75.093334 22.755555 18.204444-197.973333 182.044444-349.297778 376.604445-347.022222 195.697778 2.275556 364.088889 157.013333 383.431111 349.297778-21.617778-14.791111-47.786667-22.755556-73.955556-23.893334-73.955556-1.137778-134.257778 59.164444-135.395555 131.982223l-1.137778 113.777777c0 36.408889 13.653333 71.68 39.822222 96.711111-30.72 46.648889-81.92 69.404444-159.288889 70.542223-9.102222-23.893333-31.857778-38.684444-58.026666-39.822223h-45.511112c-34.133333 0-62.577778 27.306667-63.715555 61.44 0 34.133333 27.306667 62.577778 61.44 63.715556h45.511111c21.617778 0 42.097778-10.24 53.475556-28.444444 100.124444-1.137778 169.528889-32.995556 212.764444-97.848889 13.653333 5.688889 28.444444 7.964444 44.373333 7.964444 73.955556 1.137778 134.257778-59.164444 135.395556-131.982222l3.413333-184.32z m-61.44 70.542222l-1.137778 113.777778c0 42.097778-35.271111 76.231111-77.368888 76.231111s-76.231111-35.271111-76.231112-77.368889l1.137778-113.777778c0-42.097778 35.271111-76.231111 77.368889-76.231111 42.097778 0 76.231111 35.271111 76.231111 77.368889z m-762.311111 111.502222l1.137778-113.777777c0-42.097778 35.271111-76.231111 77.368889-76.231112 42.097778 0 76.231111 35.271111 76.231111 77.368889l-1.137778 113.777778c0 42.097778-35.271111 76.231111-77.368889 76.231111s-76.231111-35.271111-76.231111-77.368889z" p-id="1702"></path>
            </svg> */}
      <svg
        width="21.23"
        height="23"
        viewBox="0 0 24 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 15.75C7 14.3693 5.88071 13.25 4.5 13.25C3.11929 13.25 2 14.3693 2 15.75V18.25C2 19.6307 3.11929 20.75 4.5 20.75C5.88071 20.75 7 19.6307 7 18.25V15.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 15.75C22 14.3693 20.8807 13.25 19.5 13.25C18.1193 13.25 17 14.3693 17 15.75V18.25C17 19.6307 18.1193 20.75 19.5 20.75C20.8807 20.75 22 19.6307 22 18.25V15.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 15.75V12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12V15.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5 20.75C19.5 21.7446 18.7098 22.6984 17.3033 23.4017C15.8968 24.1049 13.9891 24.5 12 24.5"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const StoreIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      {/* <svg t="1628582541276" className="icon" viewBox="0 0 1024 1024" version="1.1" p-id="5375" width="20" height="20" fill="currentColor">
                <path stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M984.436364 514.327273l-139.636364-46.545455c-11.636364-4.654545-25.6 2.327273-30.254545 13.963637-4.654545 11.636364 2.327273 25.6 13.963636 30.254545l123.345454 41.890909V977.454545H69.818182V551.563636l123.345454-41.890909c11.636364-4.654545 18.618182-16.290909 13.963637-30.254545-4.654545-11.636364-16.290909-18.618182-30.254546-13.963637l-139.636363 46.545455c-6.981818 4.654545-13.963636 13.963636-13.963637 23.272727v465.454546c0 13.963636 9.309091 23.272727 23.272728 23.272727h930.90909c13.963636 0 23.272727-9.309091 23.272728-23.272727V535.272727c0-9.309091-6.981818-18.618182-16.290909-20.945454z" p-id="5376"></path><path d="M395.636364 535.272727c13.963636 0 23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272728 23.272727v46.545455c0 13.963636 9.309091 23.272727 23.272728 23.272727zM512 535.272727c13.963636 0 23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272727 23.272727v46.545455c0 13.963636 9.309091 23.272727 23.272727 23.272727zM651.636364 465.454545c0-13.963636-9.309091-23.272727-23.272728-23.272727s-23.272727 9.309091-23.272727 23.272727v46.545455c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272728-23.272727v-46.545455zM372.363636 674.909091c0 13.963636 9.309091 23.272727 23.272728 23.272727s23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272728 23.272727v46.545455zM488.727273 674.909091c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272727 23.272727v46.545455zM628.363636 698.181818c13.963636 0 23.272727-9.309091 23.272728-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272728-23.272727s-23.272727 9.309091-23.272727 23.272727v46.545455c0 13.963636 9.309091 23.272727 23.272727 23.272727zM861.090909 698.181818c13.963636 0 23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272727 23.272727v46.545455c0 13.963636 9.309091 23.272727 23.272727 23.272727zM186.181818 628.363636c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272727 23.272727v46.545455c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272727-23.272727v-46.545455zM837.818182 837.818182c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272727 23.272727v46.545455zM162.909091 768c-13.963636 0-23.272727 9.309091-23.272727 23.272727v46.545455c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272727-23.272727v-46.545455c0-13.963636-9.309091-23.272727-23.272727-23.272727zM581.818182 954.181818c13.963636 0 23.272727-9.309091 23.272727-23.272727v-162.909091c0-13.963636-9.309091-23.272727-23.272727-23.272727h-139.636364c-13.963636 0-23.272727 9.309091-23.272727 23.272727v162.909091c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272727-23.272727v-139.636364h93.09091v139.636364c0 13.963636 9.309091 23.272727 23.272727 23.272727z" p-id="5377"></path><path d="M232.727273 372.363636h23.272727v535.272728c0 13.963636 9.309091 23.272727 23.272727 23.272727s23.272727-9.309091 23.272728-23.272727V349.090909c0-13.963636-9.309091-23.272727-23.272728-23.272727h-20.945454c13.963636-104.727273 123.345455-186.181818 253.672727-186.181818s239.709091 81.454545 253.672727 186.181818H744.727273c-13.963636 0-23.272727 9.309091-23.272728 23.272727v558.545455c0 13.963636 9.309091 23.272727 23.272728 23.272727s23.272727-9.309091 23.272727-23.272727V372.363636h23.272727c13.963636 0 23.272727-9.309091 23.272728-23.272727 0-134.981818-123.345455-244.363636-279.272728-256V23.272727c0-13.963636-9.309091-23.272727-23.272727-23.272727s-23.272727 9.309091-23.272727 23.272727v69.818182c-155.927273 11.636364-279.272727 121.018182-279.272728 256 0 13.963636 9.309091 23.272727 23.272728 23.272727z" p-id="5378"></path><path d="M512 209.454545c-51.2 0-93.090909 41.890909-93.090909 93.09091s41.890909 93.090909 93.090909 93.090909 93.090909-41.890909 93.090909-93.090909-41.890909-93.090909-93.090909-93.09091z m0 139.636364c-25.6 0-46.545455-20.945455-46.545455-46.545454s20.945455-46.545455 46.545455-46.545455 46.545455 20.945455 46.545455 46.545455-20.945455 46.545455-46.545455 46.545454z" p-id="5379"></path>
            </svg> */}
      <svg
        width="23"
        height="23"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.75 24.25H24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.75 8C16.75 8.99456 17.1451 9.94839 17.8483 10.6517C18.5516 11.3549 19.5054 11.75 20.5 11.75C21.4946 11.75 22.4484 11.3549 23.1517 10.6517C23.8549 9.94839 24.25 8.99456 24.25 8V6.75H1.75L4.25 1.75H21.75L24.25 6.75M1.75 6.75V8C1.75 8.99456 2.14509 9.94839 2.84835 10.6517C3.55161 11.3549 4.50544 11.75 5.5 11.75C6.49456 11.75 7.44839 11.3549 8.15165 10.6517C8.85491 9.94839 9.25 8.99456 9.25 8V6.75H1.75ZM9.25 8C9.25 8.99456 9.64509 9.94839 10.3483 10.6517C11.0516 11.3549 12.0054 11.75 13 11.75C13.9946 11.75 14.9484 11.3549 15.6517 10.6517C16.3549 9.94839 16.75 8.99456 16.75 8V6.75L9.25 8Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.25 24.25V11.5625"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.75 24.25V11.5625"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 24.25V19.25C9.25 18.587 9.51339 17.9511 9.98223 17.4822C10.4511 17.0134 11.087 16.75 11.75 16.75H14.25C14.913 16.75 15.5489 17.0134 16.0178 17.4822C16.4866 17.9511 16.75 18.587 16.75 19.25V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const PartnerIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      {/* <svg t="1628584106222" className="icon" viewBox="0 0 1024 1024" p-id="8814" width="20" height="20" fill="currentColor">
                <path stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M1008 1024H16a16 16 0 0 1 0-32h992a16 16 0 0 1 0 32z" fill="#1D1D1D" p-id="8815"></path>
                <path stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M688 1024H80a16 16 0 0 1-16-16V16a16 16 0 0 1 16-16h608a16 16 0 0 1 16 16v992a16 16 0 0 1-16 16zM96 992h576V32H96v960z" p-id="8816"></path>
                <path stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M944 1024H688a16 16 0 0 1-16-16V384a16 16 0 0 1 16-16h256a16 16 0 0 1 16 16v624a16 16 0 0 1-16 16z m-240-32h224V400H704v592zM528 1024a16 16 0 0 1-16-16V832a16 16 0 0 1 32 0v176a16 16 0 0 1-16 16z" p-id="8817"></path>
                <path stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M560 848H208a16 16 0 0 1 0-32h352a16 16 0 0 1 0 32z" p-id="8818"></path>
                <path stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="M240 1024a16 16 0 0 1-16-16V832a16 16 0 0 1 32 0v176a16 16 0 0 1-16 16zM384 1024a16 16 0 0 1-16-16V832a16 16 0 0 1 32 0v176a16 16 0 0 1-16 16zM272 224h-96a16 16 0 0 1-16-16V112a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64V128h-64v64zM432 224h-96a16 16 0 0 1-16-16V112a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64V128h-64v64zM592 224h-96a16 16 0 0 1-16-16V112a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64V128h-64v64zM272 400h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM432 400h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM592 400h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM272 576h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM432 576h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM592 576h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM272 752h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM432 752h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM592 752h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM864 576h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM864 752h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM864 928h-96a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-80-32h64v-64h-64v64zM336 944c-4.16 0-8.32-1.76-11.36-4.64-2.88-3.04-4.64-7.2-4.64-11.36 0-4.16 1.76-8.32 4.64-11.36 6.08-5.92 16.8-5.92 22.72 0 2.88 3.04 4.64 7.2 4.64 11.36 0 4.16-1.76 8.32-4.64 11.36-3.04 2.88-7.2 4.64-11.36 4.64zM432 944c-4.16 0-8.32-1.76-11.36-4.64-2.88-3.04-4.64-7.2-4.64-11.36 0-4.16 1.76-8.32 4.64-11.36 6.08-5.92 16.64-5.92 22.72 0 2.88 3.04 4.64 7.2 4.64 11.36 0 4.16-1.76 8.32-4.64 11.36-3.04 2.88-7.2 4.64-11.36 4.64z" p-id="8819"></path>
            </svg> */}
      <svg
        width="23"
        height="23"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.75 24.25H24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.25 24.25V6.75L14.25 1.75V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.75 24.25V11.75L14.25 6.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 9.25V9.2625"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 13V13.0125"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 16.75V16.7625"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 20.5V20.5125"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const SellerIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="23"
        height="23"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.25 11.75C12.0114 11.75 14.25 9.51142 14.25 6.75C14.25 3.98858 12.0114 1.75 9.25 1.75C6.48858 1.75 4.25 3.98858 4.25 6.75C4.25 9.51142 6.48858 11.75 9.25 11.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.75 24.25V21.75C1.75 20.4239 2.27678 19.1521 3.21447 18.2145C4.15215 17.2768 5.42392 16.75 6.75 16.75H11.75C13.0761 16.75 14.3479 17.2768 15.2855 18.2145C16.2232 19.1521 16.75 20.4239 16.75 21.75V24.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 1.91248C19.0755 2.18785 20.0288 2.81335 20.7095 3.69036C21.3903 4.56738 21.7598 5.64601 21.7598 6.75623C21.7598 7.86644 21.3903 8.94508 20.7095 9.82209C20.0288 10.6991 19.0755 11.3246 18 11.6"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.25 24.25V21.75C24.2437 20.6464 23.8724 19.576 23.1941 18.7055C22.5158 17.835 21.5685 17.2134 20.5 16.9375"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const MergeIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 23,
        maxWidth: 23
      }}
    >
      <svg
        width="23"
        height="23"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 1.75H15.5V6.75H10.5V1.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.75 19.25H6.75V24.25H1.75V19.25Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.25 19.25H24.25V24.25H19.25V19.25Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 19.25L13 14.25L19.25 19.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 6.75V14.25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const SupervisorIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        maxHeight: 24,
        maxWidth: 24
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 8.75C16.3807 8.75 17.5 7.63071 17.5 6.25C17.5 4.86929 16.3807 3.75 15 3.75C13.6193 3.75 12.5 4.86929 12.5 6.25C12.5 7.63071 13.6193 8.75 15 8.75Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 26.25C7.63071 26.25 8.75 25.1307 8.75 23.75C8.75 22.3693 7.63071 21.25 6.25 21.25C4.86929 21.25 3.75 22.3693 3.75 23.75C3.75 25.1307 4.86929 26.25 6.25 26.25Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.75 26.25C25.1307 26.25 26.25 25.1307 26.25 23.75C26.25 22.3693 25.1307 21.25 23.75 21.25C22.3693 21.25 21.25 22.3693 21.25 23.75C21.25 25.1307 22.3693 26.25 23.75 26.25Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 21.25C17.0711 21.25 18.75 19.5711 18.75 17.5C18.75 15.4289 17.0711 13.75 15 13.75C12.9289 13.75 11.25 15.4289 11.25 17.5C11.25 19.5711 12.9289 21.25 15 21.25Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 8.75V13.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.375 22.25L11.875 19.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.625 22.25L18.125 19.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export {
  UserIcon,
  ContractSettingsIcon,
  CustomerIcon,
  ContractIcon,
  BenefitsIcon,
  DemoIcon,
  DocumentIcon,
  DashboardIcon,
  RequestIcon,
  AdvisorIcon,
  StoreIcon,
  PartnerIcon,
  SellerIcon,
  MergeIcon,
  SupervisorIcon
};
